import styled from '@emotion/styled';
import { Select } from 'antd';
import CancelSvgComponent from 'assets/svg/Cancel';
import Cross from 'assets/svg/Cross';
import DownSvg from 'assets/svg/Down';
import { colorConstants } from 'config/colorConstants';
import React, { FC, useState } from 'react';
import tw from 'twin.macro';

const placeholderText = '+ Add Variable';
const placeholderTextAlt = '+ Add Selection';

const CustomSelect = styled(Select)`
    .ant-select-clear {
        opacity: 1;
        transform: translateY(-50%);
        font-size: ${(props) => (props.mode === 'multiple' ? '18px' : 'auto')};
        margin-top: ${(props) => (props.mode === 'multiple' ? '-7px' : '0.5px')};
        background: ${(props) => (props.value ? colorConstants.grey : 'white')};
    }
    .ant-select-selector {
        height: 100% !important;
        box-shadow: none !important;
        border: none !important;
        display: flex;
        align-items: center;
        text-align: ${(props) => (props.value ? '' : 'center')};
        border-radius: 4px;
        background: ${(props) => (props.value && props.mode !== 'multiple' ? colorConstants.grey : 'white')} !important;
    }
    .ant-select-selection-search-input {
        height: 100% !important;
    }

    .ant-select-selection-item {
        font-weight: 500;
    }
    .ant-select-arrow {
        ${tw`text-purpleFont`}
        font-size:13px;
    }
`;

const crossIcon = (
    <svg width="10" height="10" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.33366 0.666687L0.666992 7.33335M0.666992 0.666687L7.33366 7.33335"
            stroke="#44338A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);

interface Props {
    options: any[];
    value: any;
    index: number;
    onChange: (val: any, item: any, index: number) => void;
    from: 'growth-analysis' | 'score-card';
    loading?: boolean;
}

const SubFilterDropdown: FC<Props> = ({ options, value, index, onChange, from, loading = false }) => {
    const CloseIcon = () => {
        return (
            <>
                {from === 'growth-analysis' ? (
                    <span className={`font-sm text-purpleFont ${value ? 'bg-bgBackground' : ''}`}>
                        <Cross />
                    </span>
                ) : (
                    <span className={`font-sm text-purpleFont `}>
                        <Cross />
                    </span>
                )}
            </>
        );
    };

    const TagRenderer = ({ item }: { item: any }) => {
        if (!item.label)
            return (
                <div className="text-black relative left-[16px] text-center text-[12px] text-opacity-30">
                    {placeholderTextAlt}
                </div>
            );
        return (
            <div className="bg-purpleFont  text-[10px] text-white py-1 px-2 rounded">
                {item.label?.length > 10 ? `${item.label?.slice(0, 10)}...` : item.label}
            </div>
        );
    };

    return (
        <div>
            {/* FOR GROWTH ANALYSIS */}
            {from === 'growth-analysis' ? (
                <CustomSelect
                    disabled={loading}
                    loading={loading}
                    value={value}
                    onChange={(val, item) => onChange(val, item, index)}
                    className={`rounded font-xs dropdown-height h-auto uniqSelGrowthAnalysisDropdown !text-purpleFont font-medium border border-purpleFont dropdown-width-alt  ${
                        value ? 'border border-opacity-40' : 'border-dashed'
                    }`}
                    placeholder={placeholderText}
                    dropdownStyle={{ fontSize: 30 }}
                    allowClear={index !== 0}
                    clearIcon={<CloseIcon />}
                    showArrow={index === 0}
                    options={options}
                    suffixIcon={<DownSvg />}
                />
            ) : (
                //FOR PROMO SCORE CARD
                <CustomSelect
                    disabled={loading}
                    loading={loading}
                    tagRender={(item) => {
                        return <TagRenderer item={item} />;
                    }}
                    mode="multiple"
                    value={value}
                    onChange={(val: any, item: any) => onChange(val[1], item[1], index)}
                    className={`rounded font-xs !text-purpleFont uniqSelPromoScoreCardDropdown dropdown-width-alt dropdown-height font-medium border border-purpleFont !bg-white  ${'border-dashed'}`}
                    style={{ height: 32 }}
                    placeholder={placeholderTextAlt}
                    allowClear={value !== null}
                    //clearIcon={value !== null ? <CloseIcon /> : ''}
                    showArrow={false}
                    options={options}
                    showSearch={false}
                    maxTagCount={1}
                />
            )}
        </div>
    );
};

export default SubFilterDropdown;
